import { Routes } from '@angular/router';

export const batchProcessingRoutes: Routes = [
  {
    path: 'batch-processing',
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import('./pages/batch-processing/batch-processing').then((m) => m.BatchProcessing),
      },
      {
        path: 'batch-preparation-upload',
        loadComponent: () =>
          import('./pages/batch-preparation-upload/batch-preparation-upload.component').then((m) => m.BatchPreparationUploadComponent),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/reports').then((m) => m.Reports),
      },
      {
        path: 'compare',
        loadComponent: () =>
          import('./pages/comparison/comparison').then((m) => m.Comparison),
      },
      {
        path: 'analysis',
        loadComponent: () =>
          import('./pages/analysis/analysis').then((m) => m.Analysis),
      },
      {
        path: ':batchId',
        loadComponent: () =>
          import('./pages/batch-detail/batch-detail').then((m) => m.BatchDetail),
      },
    ],
  },
];
